<template>
  <div
    class="mb-1 flex flex-col gap-3 p-2 bg-white dark:bg-dmGray1 border border-neutral6 dark:border-dmGray1 rounded"
    :class="{ 'bg-redLight border-redDark': Number(shipment.storage.fee) > 0 }">
    <div class="flex flex-col 2xl:flex-row gap-2 pt-1">
      <span class="text-xs">{{ t('site_pro.additional_services.storage_fee.title') }}</span>

      <div class="flex gap-2">
        <Tooltip :text="toolTipText.storage_fee">
          <i class="fa-solid fa-question-circle text-neutral3 dark:text-dmText3 cursor-pointer" />
        </Tooltip>
      </div>
    </div>
    <div>{{ toPrice(shipment.storage.fee) }}</div>
  </div>
</template>

<script lang="ts" setup>
import type { PackageInterface } from '~/types/shipzeePro/packagesTypes'

import { useLang } from '~/composables/useLang'
import { useSiteProContentStore } from '~/store/shipzeeProContentStore'
import toPrice from '../../../utils/toPrice'
import Tooltip from '~/components/Tooltip.vue'

defineProps<{
  shipment: PackageInterface
}>()

const { t } = useLang()
const contentStore = useSiteProContentStore()

const toolTipText = computed(() => {
  return {
    storage_fee: t('site_pro.additional_services.storage_fee.tooltip_description', {
      price: String(toPrice(contentStore.additionalServicesConfig?.storage.price_per_day)),
      days_limit: contentStore.additionalServicesConfig?.storage.free_days ?? 0,
    }),
  }
})
</script>
